import React, { useState, useEffect, useCallback } from 'react';
import { talukaAPI } from '../../services/api';

export default function TalukaGPs() {
  const [gps, setGps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await talukaAPI.getGrampanchayats();
      const data = res.data?.grampanchayats || res.data?.data || res.data || [];
      setGps(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load Grampanchayats');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = gps.filter(g =>
    !search || g.name?.toLowerCase().includes(search.toLowerCase()) ||
    g.sarpanch_name?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}>Loading…</div>;
  if (error)   return <div style={{ textAlign: 'center', padding: 60, color: '#c62828' }}>{error}</div>;

  return (
    <div>
      <div className="tk-page-header">
        <h1>Grampanchayats</h1>
        <p>All Grampanchayats in your taluka ({gps.length} total)</p>
      </div>

      <div className="tk-filter-bar" style={{ marginBottom: 20 }}>
        <input
          placeholder="Search by name or sarpanch…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="tk-gp-grid">
        {filtered.map((g, i) => (
          <div key={g.id || i} className="tk-gp-card">
            <h3>{g.name}</h3>
            <p>📍 {g.taluka}{g.district ? `, ${g.district}` : ''}</p>
            {g.sarpanch_name && <p>👤 Sarpanch: {g.sarpanch_name}</p>}
            {g.phone && <p>📞 {g.phone}</p>}
            {g.email && <p>✉️ {g.email}</p>}
            <div className="tk-gp-stats">
              <div className="tk-gp-stat">
                <span>{(g.citizenCount ?? 0).toLocaleString()}</span>
                <span>Citizens</span>
              </div>
              <div className="tk-gp-stat">
                <span>{(g.householdCount ?? 0).toLocaleString()}</span>
                <span>Households</span>
              </div>
              <div className="tk-gp-stat">
                <span>{(g.complaintCount ?? 0).toLocaleString()}</span>
                <span>Complaints</span>
              </div>
            </div>
            <div style={{ marginTop: 10 }}>
              <span className={`tk-badge ${g.is_active ? 'tk-badge-active' : 'tk-badge-inactive'}`}>
                {g.is_active ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div style={{ textAlign: 'center', padding: 40, color: '#888' }}>No Grampanchayats found.</div>
      )}
    </div>
  );
}
